import config from '../../../config'
import axios from 'axios'

let NutritionApi = {
  getNutritionCard() {
    return axios.get(config.apiUrl + 'tracking/nutrition/card/?requestFrom=web')
  }
};

export default NutritionApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/Nutrition/index.js